import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-clone-dialog]';
const PLUGIN_NAME = 'CloneDialog';
const elements = document.querySelectorAll(ELEMENT_SELECTOR);

if (elements.length) {
	System.import(
		/* webpackChunkName: "clone-dialog" */ './clone-dialog'
	).then((module) => {
		plugin(PLUGIN_NAME, module.default);
		$(elements)[PLUGIN_NAME]();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/clone-dialog/index--split.js